// Ported from packages/desk/src/mobile/Greeting.tsx (docs/PLAN-2026-09-21-mobile-os-shell.md, step 4). Same file name and props
// as the desk copy, the dk- prefix renamed rdr-, so a fix in one is a copy in the other. Radar never imports @gamo/desk.
/** "Good afternoon" by the local hour, the date, and one live line from the host (a real number, never decoration). */
import { useEffect, useState } from "react";
import { greetingFor } from "./layout";
import type { MobileStat } from "./types";

function useMinute(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);
  return now;
}

export function Greeting({ stat }: { stat?: MobileStat | null | undefined }) {
  const now = useMinute();
  const date = now.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
  return (
    <section className="rdr-mgreet" aria-label="Today" data-rdr-greeting="">
      <div className="rdr-mgreet-main">
        <p className="rdr-mgreet-hello">{greetingFor(now.getHours())}</p>
        {stat &&
          (stat.onOpen ? (
            <button type="button" className="rdr-mgreet-stat link" onClick={stat.onOpen}>
              {stat.line}
            </button>
          ) : (
            <p className="rdr-mgreet-stat">{stat.line}</p>
          ))}
      </div>
      <p className="rdr-mgreet-date">{date}</p>
    </section>
  );
}
